import React, { useEffect, useRef, useState } from 'react';
import { API_BASE_URL } from '../config';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import NavigationBar from '../components/Navbar/navbar';
import '../styles/education-style.css';
import '../styles/responsive.css';
import { jwtDecode } from 'jwt-decode';
//images
import SearchIcon from '../images/home-landing-page/search-icon.png';
import DirectoryIcon from '../images/home-landing-page/directory-icon.png';
import JobIcon from '../images/home-landing-page/job-icon.png';
import ChatIcon from '../images/home-landing-page/chat-icon.png';
import SocialMediaIcon from '../images/home-landing-page/social-media-icons.png';
import Job1 from '../images/home-landing-page/job-1.png';
import Job2 from '../images/home-landing-page/job-2.png';
import Job3 from '../images/home-landing-page/job-3.png';
import Job4 from '../images/home-landing-page/job-4.png';
import CoworkerIcon from '../images/home-landing-page/co-workers.png';
import customerAvtar from '../images/home-landing-page/customer-avatar.png';
import EfficientIcon from '../images/home-landing-page/efficient-icon.png';
import Footer from '../components/Footer/footer';
import DashboardNavbar from '../components/Navbar/navbar-dashboard';
import BannerVector from '../images/home-landing-page/banner-round-vector.png';
import ConnectWithClientsImage from '../images/home-landing-page/buildings-vector.png';
import User1 from '../images/home-landing-page/user1.png';
import User2 from '../images/home-landing-page/user2.png';
import User3 from '../images/home-landing-page/user3.png';
import ReviewStar from '../images/home-landing-page/review-star.svg';
import Slider from "react-slick";


import picprivatecertifier from '../assets/images/edu/pc.png';
import pictownplanner from '../assets/images/edu/townplanner.png';
import picprojman from '../assets/images/edu/project-man-profile.png';
import picprocesses from '../assets/images/edu/processes.png';
import picbuilderprofile from '../assets/images/edu/builder-profile.png';
import piccarpenter from '../assets/images/edu/carpenter.png';
import picbuilders from '../assets/images/edu/builders.png';
import pichandy from '../assets/images/edu/pichandy.png';

const EducationLanding = () =>
{
  const [searchTerm, setSearchTerm] = useState('');
  const [postCode, setPostCode] = useState('');
  const [results, setResults] = useState([]);
  const [username, setUsername] = useState('');
  const navigate = useNavigate();
  const MAX_RESULTS = 20;

  const handleLoginClick = () =>
  {
    navigate('/home-user-login');
  };

  const handleSignupClick = () =>
  {
    navigate('/register-home-user');
  };

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "275px",
    slidesToShow: 3,
    speed: 500,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 3,
          centerPadding: "200px",
        },
      },
      {
        breakpoint: 1499,
        settings: {
          slidesToShow: 2,
          centerPadding: "175px",
        },
      },
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 2,
          centerPadding: "75px",
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
    ],
  };

  useEffect(() =>
  {
    const token = localStorage.getItem('token');
    if (token !== null)
    {
      const decodeToken = jwtDecode(token);
      setUsername(decodeToken.UserName);
    }
  }, [username]);

  const handleSearchChange = async (e) =>
  {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);

    if (searchValue.length > 0)
    {
      try
      {
        const response = await axios.get(`${API_BASE_URL}/api/Search/searchprofessions?search=${searchValue}`);
        setResults(response.data.slice(0, MAX_RESULTS)); // Limit to MAX_RESULTS
      } catch (error)
      {
        console.error('Error fetching professions:', error);
      }
    } else
    {
      setResults([]);
    }
  };




  // Set the selected profession in the search box and clear results
  const addItem = (item) =>
  {
    setSearchTerm(`${item.name}`); // Set the search term to selected item
    setResults([]); // Clear the dropdown
  };

  return (
    <div >
      {username ? (<DashboardNavbar prefix={''} />) : (<NavigationBar handleLoginClick={handleLoginClick} handleSignupClick={handleSignupClick} prefix={''} />)}


        <div class="search-job-page">
        {/* No username - not logged in */}

          <section class="connect-with-clients blue_bg_section" style={{paddingTop: 20}}>
            <div class="container">
              <div class="row">
                <div class="col-sm-12">
                  <h2>Build Start Learning Centre</h2>
                </div>
              </div>
            </div>
          </section>


          <section class="search-banner">
          <div class="container">
            <div class="row">
              <div class="col-sm-12">

                <div class="search-options">
                  <h3>WHAT DO YOU WANT TO DO?</h3>
                  <div class="options-mylist">

                  <a class="option-box2" href='/edubiz'>
                      <figure class="icon-list2">
                        <img src={pichandy} />
                      </figure>
                      <span>
                        Original Education Page
                      </span>
                    </a>

                    <a class="option-box2" href='/videos'>
                      <figure class="icon-list2">
                        <img src={picprocesses} />
                      </figure>
                      <span>
                        Videos
                      </span>
                    </a>
                    <a class="option-box2" href='/meetpros'>
                      <figure class="icon-list2">
                        <img src={picbuilders} />
                      </figure>
                      <span>
                        Understand Building Speak and Terminology
                      </span>
                    </a>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>





        </div>


      <Footer />
    </div>
  );
}

export default EducationLanding;